import { Injectable } from '@angular/core';
import { StoreService } from '../store.service';
import { AccountService } from './account.service';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  liveEdit = false;

  constructor(private store : StoreService, private account : AccountService) {
  }

  isAdmin() {
    
  }
}
